import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
  type InputSignal,
  type OutputEmitterRef,
  type Signal,
} from '@angular/core';
import { UiAvatarComponent } from '../ui-avatar/ui-avatar.component';
import { UiBadgeComponent } from '../ui-badge/ui-badge.component';
import { UiLibraryIconComponent } from '../ui-library-icon/ui-library-icon.component';
import { UiLibraryIconName } from '../../types/ui-library-icon-name.type';
import { UiOwnerTone } from '../../types/ui-owner-tone.type';

@Component({
  selector: 'ui-library-item-row',
  imports: [UiAvatarComponent, UiBadgeComponent, UiLibraryIconComponent],
  templateUrl: './ui-library-item-row.component.html',
  styleUrl: './ui-library-item-row.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiLibraryItemRowComponent {
  public readonly title: InputSignal<string> = input.required<string>();
  public readonly subtitle: InputSignal<string | null> = input<string | null>(null);
  public readonly badge: InputSignal<string | null> = input<string | null>(null);
  public readonly imageUrl: InputSignal<string | null> = input<string | null>(null);
  public readonly iconName: InputSignal<UiLibraryIconName | null> = input<UiLibraryIconName | null>(null);
  public readonly iconLabel: InputSignal<string> = input<string>('?');
  public readonly ownerInitials: InputSignal<string> = input.required<string>();
  public readonly ownerLabel: InputSignal<string> = input.required<string>();
  public readonly ownerLabelVisible: InputSignal<boolean> = input<boolean>(false);
  public readonly ownerTone: InputSignal<UiOwnerTone> = input<UiOwnerTone>('neutral');
  public readonly disabled: InputSignal<boolean> = input<boolean>(false);
  public readonly selected: OutputEmitterRef<void> = output<void>();

  protected readonly hasSubtitle: Signal<boolean> = computed((): boolean => !!this.subtitle());
  protected readonly hasBadge: Signal<boolean> = computed((): boolean => !!this.badge());
  protected readonly hasImage: Signal<boolean> = computed((): boolean => !!this.imageUrl());

  protected handleSelected(event: MouseEvent): void {
    if (this.disabled()) {
      event.preventDefault();
      return;
    }

    this.selected.emit();
  }
}
